module.exports = __webpack_public_path__ + "5ccf14a4422f7435908897ecaaf6e26b.svg";